import React from 'react';
import { Button, Modal, Tooltip } from 'antd';
import { DeleteOutlined, CloseOutlined, TagOutlined } from '@ant-design/icons';
import '../../styles/SelectionBox.css';

interface BatchActionBarProps {
  selectedCount: number;
  onDelete: () => Promise<void>;
  onClearSelection: () => void;
  visible: boolean;
}

export const BatchActionBar: React.FC<BatchActionBarProps> = ({
  selectedCount,
  onDelete,
  onClearSelection,
  visible,
}) => {
  if (!visible) return null;

  const handleDelete = () => {
    Modal.confirm({
      title: '确认批量删除',
      content: `确定要删除选中的 ${selectedCount} 个帖子吗？此操作不可撤销。`,
      okText: '确认删除',
      okType: 'danger',
      cancelText: '取消',
      onOk: async () => {
        await onDelete();
      },
    });
  };

  return (
    <div className="batch-action-bar">
      <div className="batch-action-bar-content">
        <span className="batch-action-bar-count">
          已选择 <strong>{selectedCount}</strong> 个帖子
        </span>
        <div className="batch-action-bar-buttons">
          <Tooltip title="功能开发中，急的话去催催 Chill">
          <Button
            disabled
            icon={<TagOutlined />}
          >
            添加标签
          </Button>
          </Tooltip>
          <Button
            type="primary"
            danger
            icon={<DeleteOutlined />}
            onClick={handleDelete}
          >
            删除
          </Button>
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={onClearSelection}
          >
            取消选择
          </Button>
        </div>
      </div>
    </div>
  );
};
